<template>
    <nav class="pagination is-centered" role="navigation" aria-label="pagination">
        <a @click="() => changePage(actualPage - 1)"
            :class="['pagination-previous', { 'is-disabled-local': actualPage == 1 }]">Anterior</a>
        <a @click="() => changePage(actualPage + 1)"
            :class="['pagination-next', { 'is-disabled-local': actualPage == maxPages }]">Siguiente</a>
        <ul class="pagination-list">
            <li v-if="actualPage > 2"> <a @click="() => changePage(1)" class="pagination-link">1</a></li>
            <li v-if="actualPage > 3"> <span class="pagination-ellipsis has-text-black">&hellip;</span></li>

            <li v-if="actualPage > 1"><a @click="() => changePage(actualPage - 1)" class="pagination-link">{{
                actualPage - 1 }}</a></li>
            <li>
                <a class="pagination-link is-current" aria-current="page">
                    {{ actualPage }} </a>
            </li>

            <li v-if="actualPage + 1 <= maxPages"><a @click="() => changePage(actualPage + 1)"
                    class="pagination-link">
                    {{ actualPage + 1 }} </a></li>

            <li v-if="actualPage + 2 < maxPages"><span class="pagination-ellipsis has-text-black">&hellip;</span>
            </li>
            <li v-if="actualPage + 1 < maxPages"><a @click="() => changePage(maxPages)"
                    class="pagination-link">
                    {{ maxPages }}
                </a></li>
        </ul>
    </nav>
</template>
<script>
export default {
    name: "Pagination",
    components: {
    },
    data() {
        return {
            actualPage: this.value,
        }
    },
    methods: {
        changePage(newPage) {
            if (newPage < 1 || newPage > this.maxPages) {
                return
            }
            this.actualPage = newPage
            this.$emit('input', this.actualPage)
        },
    },
    props: {
        value: Number,
        maxPages: Number
    },
    watch: {
        value(new_value) {
            this.actualPage = new_value
        }
    }
}
</script>
<style scoped></style>